<template>
  <div class="device-monitor_map">
    <BMap ref="bmap" @loaded="bmapLoaded" @mapHandler="mapHandler" />
  </div>
</template>

<script>
// import BMap from '@/components/bmapGL';
import BMap from '@/components/bmap';
import { makeDeviceMarker } from '@/utils/bmapUtil';
import { mapState } from 'vuex';

export default {
  name: 'monitorMap',
  components: { BMap },
  props: {
    res: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      labelMap: {},
      markerMap: {},
      bmap: null,
      infoWindow: null
    };
  },
  computed: {
    ...mapState('device', ['monitorMenuActive', 'monitorConfig'])
  },
  methods: {
    mapHandler(theme) {
      if (theme) {
        this.bmap.setMapStyleV2({ styleJson: theme });
      }
    },
    bmapLoaded(bmap) {
      this.bmap = bmap;
      this.$nextTick(() => {
        // const point = new (window.BMapGL || window.BMap).Point(117.21, 39.09);
        const point = new (window.BMapGL || window.BMap).Point(116.571379, 40.089125);

        this.bmap.centerAndZoom(point, 11);
      });
    },
    initMarrker() {
      let marker;
      let { longitude, latitude, state } = this.res;
      if (!longitude || !latitude) return;

      this.bmap.clearOverlays();

      marker = makeDeviceMarker({
        state: state || 0,
        coordinate: [longitude, latitude]
      });
      this.bmap.addOverlay(marker);
    },

    mapTypeChange(n) {
      this.bmap.setMapType(n);
    }
  },
  watch: {
    'monitorConfig.mapType': {
      handler: 'mapTypeChange',
      deep: true
    },
    'res.testTime': {
      deep: true,
      immediate: true,
      handler() {
        if (this.bmap) {
          this.initMarrker();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.device-monitor_map {
  height: 100%;
  width: 100%;
}
</style>
